export const actions = {
  ADD: 'add',
  EDIT: 'edit',
  WATCH: 'watch',
  DUPLICATE: 'duplicate',
};
